import { rehydrateDateAfterJsonization as V } from "../util/date-utils.js";
export default class ti {
  constructor(t, i, s, l, h) {
    (this.endpoint = t),
      (this.En = i),
      (this.publicKey = s),
      (this.Vl = l),
      (this.fl = h),
      (this.endpoint = t || null),
      (this.En = i || null),
      (this.publicKey = s || null),
      (this.Vl = l || null),
      (this.fl = h || null);
  }
  bt() {
    return {
      e: this.endpoint,
      c: this.En,
      p: this.publicKey,
      u: this.Vl,
      v: this.fl,
    };
  }
  static Rn(t) {
    return new ti(t.e, V(t.c), t.p, t.u, t.v);
  }
}
